import SelectOptionAsync from 'Component/Common/Select/SelectOptionAsync';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSetupOrder } from 'Services/Features/Order/orderSlice';
import { getBranchSchedule } from 'Services/Features/Branch/Utils/branchUtils';

const SelectRescheduleOrder = () => {
    const dispatch = useDispatch();
    const dataSetupOrder = useSelector(state => state.order.setupOrder);

    const [selectedValue, setSelectedValue] = useState(null);

    const handleChange = (selectedOption) => {
        setSelectedValue(selectedOption === null ? [] : selectedOption);
    
        // Pecah value menjadi tiga field
        const payload = selectedOption === null ? [] : {
            date: selectedOption.value.date,
            hour_start_at: selectedOption.value.hour_start_at,
            hour_end_at: selectedOption.value.hour_end_at,
        };
    
        // Simpan ke Redux state atau kirim sebagai payload
        dispatch(setSetupOrder({
            schedule_date: payload.date,
            schedule_hour_start: payload.hour_start_at,
            schedule_hour_end: payload.hour_end_at,
        }));
    };


    const promiseOptions = (inputValue, callback) => {
        dispatch(getBranchSchedule(dataSetupOrder.branch_id))
        .then((response) => {
            const scheduleData = response.payload.data;

            // Proses data menjadi array opsi
            const options = Object.entries(scheduleData).flatMap(([date, slots]) =>
                slots.map(slot => ({
                    value: {
                        date,
                        hour_start_at: slot.hour_start_at,
                        hour_end_at: slot.hour_end_at,
                    },
                    label: `${date} (${slot.hour_start_at} - ${slot.hour_end_at})`,
                }))
            );

            callback(options); // Kirim opsi ke SelectOptionAsync
        })
        .catch((error) => {
            console.error('Error fetching schedule options:', error);
            callback([]); // Kirim array kosong jika terjadi error
        });
    };

    
    return (
        <SelectOptionAsync
            promiseOptions={promiseOptions}
            handleChange={(selectedOption) => handleChange(selectedOption)}
            selectedValue={selectedValue}
            placeholder="Pilih Jadwal"
            isMulti={false}
        />
    )
}

export default SelectRescheduleOrder;
